import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-lg font-bold text-background-50" style={{ fontFamily: "var(--font-heading)" }}>
                蘑菇视频
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              蘑菇视频是领先的高清视频平台，致力于为用户提供海量正版高清视频内容。随时随地，畅享精彩视听体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/dianying" className="text-sm text-background-400 hover:text-background-200 transition-colors">电影</Link>
              <Link to="/category/dianshiju" className="text-sm text-background-400 hover:text-background-200 transition-colors">电视剧</Link>
              <Link to="/category/zongyi" className="text-sm text-background-400 hover:text-background-200 transition-colors">综艺</Link>
              <Link to="/category/dongman" className="text-sm text-background-400 hover:text-background-200 transition-colors">动漫</Link>
              <Link to="/category/jilupian" className="text-sm text-background-400 hover:text-background-200 transition-colors">纪录片</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">品牌介绍</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">联系我们</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">用户口碑</Link>
              <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors">加入我们</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">帮助支持</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors">常见问题</a>
              <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors">会员说明</a>
              <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors">使用协议</a>
              <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors">隐私政策</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2024 蘑菇视频 版权所有 | 京ICP备2024000001号 | 京公网安备11000000000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}